import React from 'react';
import TwDialog from '../TwDialog/TwDialog';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';

import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import useAuth from '../../providers/Auth/Auth.provider';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { updateDriverPayConfirmationModal } from '../../redux/features/orders/ordersSlice';
import { updateTripLtlDriverPayConfirmationModal } from '../../redux/features/trip/tripSlice';
interface TwDriverPayConfirmationModalProps {
  open: boolean;
}

const TwDriverPayConfirmationModal = ({ open }: TwDriverPayConfirmationModalProps): JSX.Element => {
  const {
    data: { userData }
  } = useAuth();
  const enableLtl = userData?.tenant?.ltl_enabled || false;
  const dispatch = useAppDispatch();

  const driverPayConfirmationModal = useAppSelector(
    (state) => state.orders.driver_pay_confirmation_modal
  );
  const tripLTLDriverPayConfirmationModal = useAppSelector(
    (state) => state.trip.driver_pay_confirmation_modal
  );

  const handleCancel = (): void => {
    // then close modal en reset action to null
    if (enableLtl) {
      dispatch(updateTripLtlDriverPayConfirmationModal({ open: false, action: null }));
    } else {
      dispatch(updateDriverPayConfirmationModal({ open: false, action: null }));
    }
  };

  const handleClearAndProceed = (): void => {
    // do action
    // then close modal en reset action to null
    if (enableLtl) {
      tripLTLDriverPayConfirmationModal.action && tripLTLDriverPayConfirmationModal.action();
      dispatch(updateTripLtlDriverPayConfirmationModal({ open: false, action: null }));
    } else {
      driverPayConfirmationModal.action && driverPayConfirmationModal.action();
      dispatch(updateDriverPayConfirmationModal({ open: false, action: null }));
    }
  };

  return (
    <TwDialog
      open={open}
      title="Clear driver pay?"
      onClickClose={handleCancel}
      actions={[
        <TwButton key="1" type={TwButtonType.secondary} label="Cancel" action={handleCancel} />,
        <TwButton
          key="2"
          type={TwButtonType.primary}
          label="Clear & proceed"
          action={handleClearAndProceed}
        />
      ]}
    >
      <div className="warning tid-warning__content">
        <Warning />
        <div className="warning__message">
          Your recent change has triggered a reset of driver pay calculations. Driver pay is cleared
          when certain updates are made, including changes to stops, rates, drivers, or trip
          structure.
        </div>
        <div className="warning__message">
          Do you want to proceed and clear the driver pay, or cancel to keep the existing driver
          pay?
        </div>
      </div>
    </TwDialog>
  );
};

export default TwDriverPayConfirmationModal;
